(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yunsho-garden-triptych"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yunsho-photo-triptych')) {
    customElements.define('yunsho-photo-triptych', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.links = Array.from(this.querySelectorAll('[data-photo-link]'));
        this.full = this.querySelector('[data-photo-full]');
        this.index = 0;
        this.links.forEach((link, index) => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.opener = link;
          this.updateImage(index);
          this.dialog.showModal();
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.querySelector('[data-photo-close]').focus();
        }, options));
        this.querySelector('[data-photo-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-photo-prev]').addEventListener('click', () => this.updateImage(this.index - 1), options);
        this.querySelector('[data-photo-next]').addEventListener('click', () => this.updateImage(this.index + 1), options);
        this.dialog.addEventListener('close', () => {
          this.imageToken = (this.imageToken || 0) + 1;
          this.dialog.removeAttribute('aria-busy');
          document.body.style.overflow = this.previousOverflow ?? '';
          this.opener?.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.updateImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
      }
      updateImage(index) {
        this.index = (index + this.links.length) % this.links.length;
        const link = this.links[this.index];
        const token = this.imageToken = (this.imageToken || 0) + 1;
        const caption = link.parentElement.querySelector('[data-photo-caption]')?.textContent ?? '';
        const alt = link.querySelector('img').alt;
        this.dialog.setAttribute('aria-busy', 'true');
        this.full.style.visibility = 'hidden';
        this.querySelector('[data-viewer-caption]').textContent = '';
        this.querySelector('[data-photo-count]').textContent = `${this.index + 1} / ${this.links.length}`;
        const pending = new Image();
        pending.onload = async () => {
          if (this.imageToken !== token || !this.isConnected) return;
          this.full.src = pending.src;
          this.full.alt = alt;
          try { await this.full.decode(); } catch {}
          if (this.imageToken !== token || !this.isConnected) return;
          this.querySelector('[data-viewer-caption]').textContent = caption;
          this.full.style.visibility = 'visible';
          this.dialog.removeAttribute('aria-busy');
        };
        pending.onerror = () => {
          if (this.imageToken !== token || !this.isConnected) return;
          this.querySelector('[data-viewer-caption]').textContent = 'This image could not be loaded. Please try another image.';
          this.dialog.removeAttribute('aria-busy');
        };
        pending.src = link.href;
      }
      disconnectedCallback() {
        if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow ?? ''; }
        this.imageToken = (this.imageToken || 0) + 1;
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yunsho-tea-pack-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yunsho-pack-summary')) {
    customElements.define('yunsho-pack-summary', class extends HTMLElement {
      connectedCallback() {
        this.packs = JSON.parse(this.querySelector('script').textContent);
        const picker = document.querySelector(`product-options-element[data-product-handle="${this.dataset.handle}"]`);
        if (!picker) return;
        this.eventName = `theme:product:${picker.dataset.id}:variantChanged`;
        this.onVariant = ({detail: {variant}}) => {
          const pack = this.packs[String(variant.id)];
          if (!pack) return;
          this.querySelector('[data-pack-details]').textContent = pack.details;
          const unit = this.querySelector('[data-pack-unit]');
          if (unit) unit.textContent = pack.unit;
          if (this.dataset.context === 'hero') {
            const stickyPrice = this.closest('form')?.querySelector('yunsho-sticky-price');
            if (stickyPrice) stickyPrice.textContent = pack.price;
          }
        };
        window.addEventListener(this.eventName, this.onVariant);
      }
      disconnectedCallback() { window.removeEventListener(this.eventName, this.onVariant); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
